import React from 'react'
import BaseIcon from 'react-icon-base'

// China for languages
const ZH = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>ZH</title>
    <defs>
      <rect id="ZH_jsx__a" width={21} height={15} rx={2} />
      <rect id="ZH_jsx__c" width={20} height={14} x={0.5} y={0.5} rx={1} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="ZH_jsx__b" fill="#fff">
        <use xlinkHref="#ZH_jsx__a" />
      </mask>
      <use fill="#CF2338" xlinkHref="#ZH_jsx__a" />
      <path
        fill="#FFD128"
        d="M2 5l3.077 1.846L4 10l2.5-2.333L9 10 7.923 6.846 11 5H2zm6 0H5l1.5-3L8 5z"
        mask="url(#ZH_jsx__b)"
      />
      <path fill="#F8B92A" d="M12 3v1h1V3h-1zm1 2v1h1V5h-1zm0 2v1h1V7h-1zm-1 2v1h1V9h-1z" mask="url(#ZH_jsx__b)" />
      <use stroke="#2F343A" strokeOpacity={0.157} xlinkHref="#ZH_jsx__c" />
    </g>
  </BaseIcon>
)

export default ZH
